export enum ClaimHistoryAction {
  Add = 'Add',
  Update = 'Update',
}
